import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../environments/environment.local';
import { version } from '../environments/version';
import { AuthService } from './order/services/internal/auth/auth.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public title = 'credenciamento';

  constructor(private authService: AuthService) {}

  // beforeunload fires earliest, giving the request time to leave before the browser tears down the
  // network context (closing an incognito window discards its profile and cancels pending requests).
  // pagehide is the fallback for cases where beforeunload doesn't fire (mobile, bfcache).
  // Both also fire on reload/navigation away; the second call is a no-op because the session is already cleared.
  @HostListener('window:beforeunload')
  @HostListener('window:pagehide')
  public onPageUnload() {
    this.authService.logoutOnUnload();
  }

  ngOnInit() {
    console.log('Application profile:', environment.profile);
    console.log('Last build date:', version.timeStamp);
    console.log('Version:', version.version);
  }
}
